<div class="content-with-stepper-and-title">
  <div class="row">
    <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4">
      <h1 class="title">
        {{copyService.copies.pay_day.title.text}} {{copyService.copies.pay_day.title.bold_text}}
      </h1>
      <p class="subtitle mt-3 my-3">{{copyService.copies.pay_day.subtitle}}</p>
      <voxel-form-field id="payDaySelectionLabel" [label]="copyService.copies.pay_day.pay_day" [description]="copyService.copies.pay_day.pay_day_bottom">
        <vcl-select id="payDayComponent" [placeholder]="copyService.copies.pay_day.pay_day_placeholder" (change)="selectOption($event)" required>
          <vcl-select-option [id]="option.day" *ngFor="let option of listDates" [selected]="option.dateFormat === selectedDate" [value]="option.dateFormat">
            {{ option.day }}
          </vcl-select-option>
        </vcl-select>
      </voxel-form-field>

    </div>
  </div>
  <footer>
  </footer>
  <app-controls [nextDisabled]="isBtnDisabled" [hasPrevious]="true" nextLabel="Continuar" (only_previous)="sendBackButtonEvent()" (next)="next()"></app-controls>
</div>
